import { RefObject } from 'react';

const submit = (ref: RefObject<HTMLFormElement>) => {
  ref.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
};
export default submit;
